import { handleActions } from '@gef-ui/utils/fsaActions';
import dissocPath from "ramda/es/dissocPath";
import mergeDeepRight from "ramda/es/mergeDeepRight";
import split from "ramda/es/split";
import mergeWithDotPath from "ramda-extension/es/mergeWithDotPath";
import { temporaryStoreActions } from '../../constants';
const initialStore = {};
const updateTemporaryStore = {
    next (state, action) {
        const { path, data } = action.payload;
        return mergeWithDotPath(path, mergeDeepRight, data, state);
    }
};
const deleteTemporaryStore = {
    next (state, action) {
        const { path } = action.payload;
        return dissocPath(split('.', path), state);
    }
};
const clearTemporaryStore = {
    next () {
        return initialStore;
    }
};
const temporaryActionsMap = {
    [temporaryStoreActions.UPDATE_TEMPORARY_STORE]: updateTemporaryStore,
    [temporaryStoreActions.DELETE_TEMPORARY_STORE]: deleteTemporaryStore,
    [temporaryStoreActions.CLEAR_TEMPORARY_STORE]: clearTemporaryStore
};
export default handleActions(temporaryActionsMap, initialStore);
